import _implicitStylesheets from "./linkWithIcon.css";
import _implicitScopedStylesheets from "./linkWithIcon.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span${3}>${"t1"}</span>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element} = $api;
  return [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": $cmp.caption
    },
    key: 0
  }, [api_element("a", {
    attrs: {
      "href": $cmp.url,
      "target": "_blank"
    },
    key: 1
  }, [api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.caption))]), api_custom_element("ax-icon", _axIcon, {
    props: {
      "size": "small",
      "icon": $cmp.icon,
      "ariaHidden": "true",
      "spriteUrl": "/images/icons.svg"
    },
    key: 4
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-43mtvprkshb";
tmpl.legacyStylesheetToken = "undefined-_linkWithIcon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
